import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpoint: `${endpointBackend}gci/all-managers/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Gestores - Geral',
        labelTitleButtonAdd: 'Incluir novo gestor',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canAdd: false,
        viewActionColumn: false,
        showActionButtons: true,
        formFilters: !profileFilter.pdc_company_id ? filters : null,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'name',
                label: 'Nome do Gestor',
                width: '25%'
            },
            {
                name: 'description',
                label: 'Tipo / Local Gestor',
                width: '55%'
            }
        ],
        columnsButtons: [
            {
                title: 'Ações',
                style: { width: '5%' },
                buttons: [
                    {
                        label: 'Ações',
                        icon: 'fas fa-magnifying-glass',
                        width: '6%',
                        onClick: async item => {
                            window.location.href = `../${item.functionality}/view/${item.id}`
                        }
                    },
                    {
                        label: '',
                        icon: 'fas fa-pencil-alt',
                        width: '6%',
                        buttonClass: '',
                        onClick: async item => {
                            window.location.href = `../${item.functionality}/edit/${item.id}`
                        }
                    },
                    {
                        label: ' ',
                        icon: 'fas fa-angles-right',
                        width: '6%',
                        onClick: async item => {
                            window.location.href = `../${item.functionality}/list`
                        }
                    }
                ]
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
